import SyncIcon from './component'

export default SyncIcon
